<template>
  <div>
    <b-card no-body header="Default">
      <div slot="header">
        <div class="float-left">
          <div class="mt-2"><b> خصوصیات </b></div>
        </div>
        <div class="float-right">
          <b-button @click="toggleCollapse" variant="success" class="ml-2">
            <i aria-hidden="true" class="fa fa-angle-down fa-lg"></i>
          </b-button>
        </div>
      </div>
      <b-collapse v-model="isCollapse" class="mt-2">
        <b-col cols="12">
          <TagComponent
            category_name="question_refrence"
            :label="$lang.question_refrence"
            :parentPermissions="parentPermissions"
            :parentValue="question_refrence_selected"
            :requiredLabel="questionReferenceSelectedRequired"
            :checkValidation="questionReferenceSelectedCheckValidation"
            @updateCheckValidation="
              questionReferenceSelectedUpdateCheckValidation
            "
            @getSelected="getQuestionReferenceSelected"
          />
        </b-col>

        <b-col xs="12">
          <b-form-group
            :label="$lang.azmoonLang.question_refrence_number"
            label-for="question_refrence_number"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.question_refrence_number"
              :rules="$v.question_refrence_number.$params"
            />
            <b-form-input
              id="question_refrence_number"
              type="text"
              :autocomplete="$lang.azmoonLang.question_refrence_number"
              v-model="$v.question_refrence_number.$model"
              :state="
                $v.question_refrence_number.$dirty
                  ? !$v.question_refrence_number.$error
                  : null
              "
              @input="changeRefrenceNumber"
            >
            </b-form-input>

            <b-form-invalid-feedback id="question_refrence_number-feedback"
              >تعداد اتاق‌ها الزامی است
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import TagComponent from "@/components/tag/tagComponent.vue";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";

export default {
  name: "question-property",
  components: {
    TagComponent,
  },
  validations: {
    question_refrence_number: {},
  },
  props: {
    id: {
      type: [String, Number],
      default: "",
    },
    data: {
      type: Object,
      default: () => {},
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isCollapse: true,
      question_refrence_selected: null,
      question_refrence_number: 0,
      questionReferenceSelectedRequired: false,
      questionReferenceSelectedCheckValidation: false,
    };
  },
  watch: {
    data(value) {
      this.question_refrence_selected = {
        text: pathOr("", ["question_refrence", "caption"], value),
        value: pathOr(null, ["question_refrence", "id"], value),
      };
      this.question_refrence_number = pathOr(
        0,
        ["question_refrence_number"],
        value
      );
    },
    question_refrence_selected(value) {
      this.changeQuestionRefrence(value);
    },
  },
  methods: {
    pathOr,
    changeQuestionRefrence(item) {
      this.$emit("selectedQuestionRefrence", item);
    },
    changeRefrenceNumber(item) {
      this.question_refrence_number = item;
      this.$emit("changeRefrenceNumber", item);
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    questionReferenceSelectedUpdateCheckValidation(data) {
      this.questionReferenceSelectedCheckValidation = data;
    },
    getQuestionReferenceSelected(data) {
      this.question_refrence_selected = data;
    },
  },
};
</script>

